export enum Timezone {
  UTC = 'UTC',
  Local = 'Local',
}
